import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/cn.ts'

export const buttonVariants = cva(
  cn(
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium',
    'transition-colors outline-none cursor-pointer',
    'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
    'disabled:pointer-events-none disabled:opacity-50',
  ),
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground hover:bg-primary-hover',
        secondary:
          'border border-border bg-background-secondary text-foreground hover:border-border-hover hover:bg-sidebar-hover-bg',
        ghost: 'text-foreground hover:bg-sidebar-hover-bg',
        outline:
          'border border-border bg-transparent text-foreground hover:border-border-hover hover:bg-sidebar-hover-bg',
        destructive: 'bg-destructive text-destructive-foreground hover:opacity-90',
      },
      size: {
        sm: 'h-8 px-3',
        md: 'h-9 px-4',
        lg: 'h-10 px-5',
        icon: 'h-9 w-9 p-0',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
